<template>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title">Рассылка команд</h2>
        <button type="button" class="close" @click="$emit('hide')" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="alert alert-primary rounded-0 m-0">
        Команды будут отправлены на <strong>{{total}} автоматов</strong>
        <br><small class="text-muted">Используйте фильтры, чтобы выбрать автоматы</small>
      </div>
      <div class="modal-body pb-0">

        <div class="form-group mb-4">
          <label class="mb-2">Тип команды</label>
          <select class="custom-select" v-model="selectedType">
            <option v-for="type in commandTypes" :value="type">{{type.type}}</option>
          </select>
        </div>

        <div class="form-group mb-4" v-if="selectedType">
          <label class="mb-2 mr-3">Время отправки</label>
          <div class="custom-control custom-radio custom-control-inline">
            <input id="date-type-1" class="custom-control-input" type="radio" :value="true" v-model="dateNow">
            <label for="date-type-1" class="custom-control-label">Сейчас</label>
          </div>
          <div class="custom-control custom-radio custom-control-inline">
            <input id="date-type-2" class="custom-control-input" type="radio" :value="false" v-model="dateNow">
            <label for="date-type-2" class="custom-control-label">Указать время</label>
          </div>
          <datetime-picker :config="options" v-if="!dateNow" v-model="date"></datetime-picker>
        </div>

        <div class="mt-4" v-if="selectedType && selectedType.withData">
          <label class="mb-2 mr-3">Данные</label>
          <div class="custom-control custom-radio custom-control-inline">
            <input type="radio" id="input-type-1" class="custom-control-input" v-model="dataTypeText" :value="true">
            <label class="custom-control-label" for="input-type-1">Текст команды </label>
          </div>
          <div class="custom-control custom-radio custom-control-inline">
            <input type="radio" id="input-type-2" class="custom-control-input" v-model="dataTypeText" :value="false">
            <label class="custom-control-label" for="input-type-2">Загрузить файл</label>
          </div>
          <textarea
            v-if="dataTypeText"
            class="form-control mt-2"
            v-model="commandData"
            rows="3"
          ></textarea>
          <div class="form-group mt-2" v-else>
            <label class="btn btn-file btn-outline-primary">
              <input @change="onFileChange($event)" type="file"/>
              Выберите файл
            </label>
            <span class="ml-1">{{fileName}}</span>
          </div>
        </div>
      </div>

      <div class="modal-footer mt-2">
        <btn-action
          class="btn btn-primary"
          @click="save" :disabled="!selectedType || (selectedType.withData && !dataTypeText && !file)"
        >Создать рассылку</btn-action>
        <button type="button" class="btn btn-outline-light" @click="$emit('hide')">Отмена</button>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'

  export default {
    props: ['filters', 'total'],
    data () {
      return {
        commandTypes: [
          {type: 'inf', withData: false},
          {type: 'cfg', withData: false},
          {type: 'eva', withData: false},
          {type: 'log', withData: true},
          {type: 'jlog', withData: true},
          {type: 'ping', withData: false},
          {type: 'reboot', withData: false},
          {type: 'bin', withData: true},
          {type: 'cfgprg', withData: true},
          {type: 'evaprg', withData: true},
          {type: 'qrbin', withData: true},
          {type: 'eva(i)', withData: false},
          {type: 'eva(pr1)', withData: false},
        ],
        options: {format: 'YYYY-MM-DD hh:mm'},
        selectedType: null,
        dataTypeText: true,
        commandData: null,
        file: null,
        dateNow: true,
        date: null,
        sortColumn: true,
      }
    },
    methods: {
      save () {
        const data = {
          type: this.selectedType.type,
          data: this.dataTypeText ? this.commandData : null,
          now: this.dateNow,
          date: this.date,
          filters: JSON.stringify(this.filters),
        }
        if (this.dataTypeText) {
          return api.post('modems/broadcast', data).then(() => {
            this.$emit('hide')
          })
        } else {
          return this.uploadFile(data)
        }
      },
      onFileChange (e) {
        const files = e.target.files || e.dataTransfer.files
        if (!files.length) return
        this.file = files[0]
      },
      uploadFile (obj) {
        const data = new FormData()
        data.append('file', this.file)
        Object.entries(obj).forEach((prop) => {
          data.append(prop[0], prop[1])
        })
        return api.post('modems/broadcast', data, {
          headers: {'content-type': 'multipart/form-data'},
        }).then(() => {
          this.$emit('hide')
        })
      },
    },
    computed: {
      fileName () {
        if (this.file) {
          return this.file.name
        } else {
          return 'Файл не выбран'
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/modems/broadcast-modal.vue